import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

const sharedCircleStyle = css`
  position: absolute;
  top: -1px;
  left: -35px;
  width: 98px;
  height: 98px;
  border-radius: 50%;
`;

export const IconBg = styled.div`
  ${sharedCircleStyle};
  background-color: rgba(115, 228, 230, 0.3);
  transition: transform 300ms;

  ${({ color }) =>
    color === 'blueGray' &&
    css`
      background-color: rgba(124, 176, 242, 0.3);
    `};

  ${({ color }) =>
    color === 'indigo' &&
    css`
      background-color: rgba(229, 229, 254, 0.3);
    `};
`;

export const IconBgLayer = styled.div`
  ${sharedCircleStyle};
  background-color: rgba(115, 228, 230, 0.6);
  transition: transform 300ms;

  ${({ color }) =>
    color === 'blueGray' &&
    css`
      background-color: rgba(124, 176, 242, 0.6);
    `};

  ${({ color }) =>
    color === 'indigo' &&
    css`
      background-color: rgba(229, 229, 254, 0.6);
    `};
`;

export const IconContainer = styled.div`
  ${sharedCircleStyle};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  border-color: ${({ color }) =>
    color ? th(`colors.${color}`) : th('colors.turquoise')};
  background-color: ${th('colors.black')};
  box-shadow: ${th('shadows.small')};
  transition: transform 300ms;
  z-index: 1;

  > img {
    width: 55%;
    height: 55%;
  }
`;

export const Children = styled.div`
  transition: opacity 200ms;

  ${({ comingSoon }) =>
    comingSoon &&
    css`
      margin-bottom: 12px;

      :after {
        content: 'COMING SOON';
        position: absolute;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 4px 36px;
        border-bottom-right-radius: 8px;
        font-size: 12px;
        text-align: right;
        letter-spacing: 2.2px;
        background-color: #5b8dcb;
        color: #bddbff;
      }
    `};
`;

const hoverChildrenStyles = css`
  position: absolute;
  top: 50%;
  left: 62%;
  width: 68%;
  transform: translate3d(-50%, -50%, 0);
  transition: opacity 400ms;
  font-size: 16px;
`;

export const HoverChildren = styled.div`
  ${hoverChildrenStyles};
`;

export const StyledProductButton = styled.button`
  position: relative;
  height: 95px;
  width: calc(100% - 35px - 12px);
  padding: 12px 14px 12px 58px;
  border: none;
  border-radius: 8px;
  outline: none;
  left: 35px;
  font-weight: bold;
  background-color: ${({ color }) =>
    color ? th(`colors.${color}`) : th('colors.turquoise')};
  color: ${th('colors.white')};
  box-shadow: ${th('shadows.small')};
  cursor: ${({ comingSoon }) => (comingSoon ? 'default' : 'pointer')};
  transition: transform 400ms;
  transition: width 400ms;
  z-index: 2;

  > ${HoverChildren} {
    opacity: 0;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      transform: translate3d(-32px, 0, 0);
    `}

  @media ${sizes.tabletPortrait} {
    width: 285px;

    :hover {
      width: 330px;

      > ${IconBg} {
        transform: scale3d(1.3, 1.3, 1);
      }

      > ${IconBgLayer} {
        transform: scale3d(1.15, 1.15, 1);
      }

      > ${IconContainer} {
        transform: scale3d(1.05, 1.05, 1);
      }

      > ${Children} {
        opacity: 0;
      }

      > ${HoverChildren} {
        opacity: 1;
      }
    }
  }
`;
